import type { RankedLeaderboardEntry } from '../leaderboard/types';
import type { LeaderboardRowView } from '../ui/leaderboard-view';
import type { ExtremeFeatureLeaderboardEntry, ExtremeRunLeaderboardEntry } from '../extreme/types';

export function toLeaderboardRows(
  entries: readonly RankedLeaderboardEntry[],
  replayIds: ReadonlySet<string> = new Set<string>(),
): readonly LeaderboardRowView[] {
  return Object.freeze(entries.map((entry) => Object.freeze({
    id: entry.clientEntryId,
    rank: entry.rank,
    name: entry.name,
    xValue: entry.profitCents / entry.betCents,
    profitCents: entry.profitCents,
    betCents: entry.betCents,
    replayAvailable: entry.replayAvailable === true || replayIds.has(entry.clientEntryId),
  })));
}

export function toExtremeRunRows(entries: readonly ExtremeRunLeaderboardEntry[]): readonly LeaderboardRowView[] {
  return Object.freeze(entries.map((entry, index) => Object.freeze({
    id: entry.id,
    rank: index + 1,
    name: entry.name,
    xValue: entry.scoreX,
    profitCents: entry.finalBalanceCents,
    betCents: 200,
    featureCount: entry.featureCount,
    replayAvailable: entry.replayAvailable,
  })));
}

export function toExtremeFeatureRows(entries: readonly ExtremeFeatureLeaderboardEntry[]): readonly LeaderboardRowView[] {
  return Object.freeze(entries.map((entry, index) => Object.freeze({
    id: entry.id,
    rank: index + 1,
    name: entry.name,
    xValue: entry.xValue,
    profitCents: entry.winCents,
    betCents: 200,
    totalSpins: entry.totalSpins,
    replayAvailable: entry.replayAvailable,
  })));
}
